import type { Permission } from '../auth/AuthProvider';
import type { IconName } from '../design';

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  permission: Permission;
  /** Fără backend până la sub-proiectul 6 (D9). */
}

export const NAV_GROUPS: { title: string; items: NavItem[] }[] = [
  {
    title: 'Operațiuni',
    items: [
      { to: '/', label: 'Prezentare generală', icon: 'dashboard', permission: 'fleet' },
      { to: '/lockere', label: 'Lockere', icon: 'locker', permission: 'fleet' },
      { to: '/harta', label: 'Harta rețelei', icon: 'map', permission: 'fleet' },
      {
        to: '/layouturi-kiosk',
        label: 'Layouturi kiosk',
        icon: 'monitor',
        permission: 'configure',
      },
      { to: '/operatiuni', label: 'Operațiuni', icon: 'operations', permission: 'operations' },
      { to: '/chei', label: 'Chei de acces', icon: 'key', permission: 'keys' },
      { to: '/documente', label: 'Documente', icon: 'document', permission: 'documents' },
      { to: '/alerte', label: 'Alerte & incidente', icon: 'alert', permission: 'alerts' },
      { to: '/rapoarte', label: 'Rapoarte', icon: 'report', permission: 'reports' },
    ],
  },
  {
    title: 'Administrare',
    items: [
      { to: '/utilizatori', label: 'Utilizatori & 2FA', icon: 'users', permission: 'users' },
      { to: '/roluri', label: 'Roluri & permisiuni', icon: 'shield', permission: 'roles' },
      { to: '/organizatii', label: 'Organizații & locații', icon: 'org', permission: 'orgs' },
      { to: '/automatizari', label: 'Automatizări', icon: 'rules', permission: 'rules' },
      { to: '/livrari', label: 'Livrări', icon: 'mail', permission: 'integrations' },
      {
        to: '/integrari',
        label: 'Integrări & API',
        icon: 'integrations',
        permission: 'integrations',
      },
      { to: '/audit', label: 'Jurnal de audit', icon: 'audit', permission: 'audit' },
      { to: '/setari', label: 'Setări & securitate', icon: 'settings', permission: 'settings' },
    ],
  },
];
